import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/previous-results", label: "Previous Results" },
  { to: "/common-numbers", label: "Common Numbers" },
  { to: "/juwai-morning-teer", label: "Juwai Teer Information" },
  { to: "/historical-results", label: "Historical Results" },
  { to: "/about", label: "About Us" },
  { to: "/contact", label: "Contact" },
  { to: "/disclaimer", label: "Disclaimer" },
];

function TargetLogo({ className = "" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <circle cx="32" cy="32" r="30" fill="#fff" stroke="#111" strokeWidth="3" />
      <circle cx="32" cy="32" r="22" fill="#fff" stroke="#111" strokeWidth="3" />
      <circle cx="32" cy="32" r="14" fill="#F04E1E" stroke="#111" strokeWidth="3" />
      <circle cx="32" cy="32" r="5" fill="#111" />
      <path d="M6 6 L34 34" stroke="#4A2E14" strokeWidth="5" strokeLinecap="round" />
      <polygon points="6,6 14,6 6,14" fill="#F04E1E" />
    </svg>
  );
}

export const Header = () => {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  return (
    <header
      className="sticky top-0 z-50 bg-white border-b border-black/5"
      data-testid="site-header"
    >
      <div className="max-w-md mx-auto sm:max-w-2xl lg:max-w-4xl px-4 sm:px-6">
        <div className="h-16 flex items-center justify-between gap-3">
          <Link
            to="/"
            className="flex items-center gap-2.5 min-w-0"
            data-testid="header-logo-link"
          >
            <TargetLogo className="w-9 h-9 shrink-0" />
            <span className="font-display font-black tracking-tight leading-none text-lg sm:text-xl truncate">
              <span className="text-black">JUWAI</span>{" "}
              <span className="text-[#F04E1E]">MORNING TEER</span>
            </span>
          </Link>
          <button
            onClick={() => setOpen((v) => !v)}
            className="p-2 rounded-lg hover:bg-black/5 transition-colors"
            aria-label="Toggle menu"
            data-testid="header-menu-toggle"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" strokeWidth={2.5} />}
          </button>
        </div>
      </div>
      {open && (
        <nav
          className="border-t border-black/5 bg-white"
          data-testid="header-mobile-nav"
        >
          <div className="max-w-md mx-auto sm:max-w-2xl lg:max-w-4xl px-4 sm:px-6 py-3 flex flex-col">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className={`px-2 py-3 border-b border-black/5 text-sm font-medium transition-colors ${
                  loc.pathname === n.to
                    ? "text-[#F04E1E]"
                    : "text-slate-700 hover:text-[#F04E1E]"
                }`}
                data-testid={`nav-link-${n.to.replace(/\//g, "") || "home"}`}
              >
                {n.label}
              </Link>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
};

export default Header;
